import Application from '@/api/applications'
import Jobseekers from '@/api/jobseekers'

export default {
  namespaced: true,
  state: {
    firstName: null,
    lastName: null,
    email: null,
    coverLetter: null,
    jobId: null,
    userId: null,
    resume: null,
    signupBoard: false
  },
  getters: {
    isValid: (state) => {
      return state.firstName && state.lastName && state.email
    },
    formData: (state) => {
      return {
        firstName: state.firstName,
        lastName: state.lastName,
        email: state.email,
        coverLetter: state.coverLetter,
        jobId: state.jobId,
        signupBoard: state.signupBoard
      }
    }
  },
  mutations: {
    setJobId (state, jobId) {
      state.jobId = jobId
    },
    setFirstName (state, firstName) {
      state.firstName = firstName
    },
    setLastName (state, lastName) {
      state.lastName = lastName
    },
    setEmail (state, email) {
      state.email = email
    },
    setCoverLetter (state, coverLetter) {
      state.coverLetter = coverLetter
    },
    setUserId (state, userId) {
      state.userId = userId
    },
    setResume (state, file) {
      state.resume = file
    },
    setSignupBoard (state, signupBoard) {
      state.signupBoard = signupBoard
    },
    resetForm (state) {
      state.firstName = null
      state.lastName = null
      state.email = null
      state.coverLetter = null
      state.signupBoard = false
    }
  },
  actions: {
    async addApplicant ({getters, commit}) {
      const formData = getters.formData
      try {
        const r = await Application.signupAndApply(formData)
        commit('resetForm')
        commit('setUserId', r.userId)
      } catch (err) {
        throw Error(err.message)
      }
    },
    async uploadResume ({state, commit}) {
      if (!state.resume) return
      try {
        await Jobseekers.uploadResumeByAdmin(state.resume, state.userId)
        commit('setResume', null)
      } catch (error) {
        throw Error(error.message)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/register-apply.js